import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div class="socials z-110">
        <a
          target="_blank"
          href="https://www.linkedin.com/in/aman-singh-418717171/"
          title="LinkedIn"
        >
          <i class="fa-brands fa-linkedin"></i>
        </a>
        <a target="_blank" href="https://wa.link/akd3o4" title="WhatsApp">
          <i class="icon fab fa-whatsapp"></i>
        </a>
      </div>
    </div>
  );
};

export default Footer;
